export default __webpack_public_path__ + "00bfaa9b8adfed4bc31f2598659ef921.png";